import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'gains-toggle',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gains-toggle.component.html',
  styleUrls: ['./gains-toggle.component.scss']
})
export class GainsToggleComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;
  switchValue = false;

  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.switchValue = params.data?.__rowToggleState === true;
    this.cdr.markForCheck();
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }

  isSkuIdentifierColumn(): boolean {
    if (!this.params?.data) {
      return false;
    }
    const column = this.params.data?.column ?? '';
    const normalized = `${column}`.trim().toLowerCase();
    return normalized === 'skul_no' || normalized === 'sku_no';
  }

  onSwitchChange(checked: boolean): void {
    this.switchValue = checked;
    const rowIndex = this.params.node?.rowIndex ?? -1;
    const onRowStatusToggle = this.params.context?.onRowStatusToggle;

    if (typeof onRowStatusToggle === 'function' && rowIndex >= 0) {
      onRowStatusToggle(rowIndex, checked);
      return;
    }

    if (this.params.data) {
      this.params.data.__panelEnabled = checked;
    }
    this.params.api.redrawRows({ rowNodes: [this.params.node] });
  }
}
